import { Component, OnInit, ViewChild } from "@angular/core";
import { UserService } from "../../../services/userService/user.service";
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import * as moment from "moment";

@Component({
  selector: "app-orderaddupdate",
  templateUrl: "./orderaddupdate.component.html",
  styleUrls: ["./orderaddupdate.component.css"],
})
export class OrderaddupdateComponent implements OnInit {
  @ViewChild("showvat") showvat: any;
  userId: any;
  permission: any;
  userRId: any;
  route: any;
  id: any;
  showProjectArray: any = [];
  showContactArray: any = [];
  showDdValuesArray: any = [];
  showClient: any = [];
  quotationArray: any = [];
  ModeArray: any = [];
  salesArray: any = [];
  commercialArray: any = [];
  showIncoArray: any = [];
  managerArray: any = [];
  financeArray: any = [];
  generalArray: any = [];
  CreditArray: any = [];
  selectedstatus1NameId: string;
  selectedInquiry: any = [];
  formdata: any = [];
  registerForm: FormGroup;
  itemDescription: FormGroup;
  approvedBy: FormGroup;
  ProjectRequirement: FormGroup;
  commercialForm: FormGroup;
  PaymentTermInfo: FormGroup;
  searchword_Con: any = "";
  currency: string = "";
  reported: string = "";
  pageSize: any = 99;
  currentPage: any = 0;
  isRender: boolean = false;
  inquiryProduct: any = [];
  totalProductSize: number;
  dollar: boolean = false;
  GrossValue: number = 0;
  TotalPrice: number = 0;
  TotalPriceQAR: number = 0;
  TotalPricewithVat: number = 0;
  TotalPricewithVatQAR: number = 0;
  previousPrice: number = 0;
  previousvat: number = 0;
  groups: any = [];
  items: any = [];
  rowvalue: any = [];
  descript: any = [];
  vat: any = [];
  productId: any = [];
  brand: any = [];
  unit: any = [];
  showmodel: any = [];
  itemShow: any;
  CategoryShow: any;
  brandShow: any;
  errror: any = "";
  isCollapsed1: boolean = false;
  dataarray: any;
  client: any = [];
  clientId: any = [];
  verticalName: any = [];
  categoryName: any = [];
  AcknowledgeArray: any = [];
  ClientArray: any = [];
  ProjectExArray: any = [];
  selectedPaymentId: any = "";
  AdvanceArray: any = [];
  shownameArray: any = [];
  showContractArray: any = [];
  tvalue: any = [];
  orderId: number = 0;
  check: number = 0;
  maxProjDate: Date;
  maxStartDate: Date;
  maxClientSoDate: Date;
  maxEqDeliverDate: Date;
  maxClientExDate: Date;
  reportedValue: number = 0;
  baseValue: number = 0;
  InquiryReceivedDate: Date;
  Modulepermi: any;
  minSoAckDate: Date;
  maxSoAckDate: Date;
  disableDate() {
    return false;
  }
  get Date() {
    return this.registerForm.get("Date") as FormControl;
  }
  get clientSoNumber() {
    return this.registerForm.get("clientSoNumber") as FormControl;
  }
  get clientSoDate() {
    return this.registerForm.get("clientSoDate") as FormControl;
  }
  get soReceiveDate() {
    return this.registerForm.get("soReceiveDate") as FormControl;
  }
  get clientExDate() {
    return this.registerForm.get("clientExDate") as FormControl;
  }

  constructor(
    private UserService: UserService,
    private formBuilder: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toastrService: ToastrService
  ) {
    this.registerForm = this.formBuilder.group({
      OrderInfoId: [0],
      soOptions: ["", Validators.required],
      criticalShipment: ["1"],
      ProjectId: ["", Validators.required],
      inquiry: ["", Validators.required],
      clientName: [""],
      clientSoReceive: ["Not Applicable"],
      remarkRcDate: ["", Validators.required],
      acknowledge: ["", Validators.required],
      projectExec: ["", Validators.required],
      eqDeliveryDate: ["", Validators.required],
      eqDeliveryRemark: ["", Validators.required],
      scopeWork: ["", Validators.required],
      clientContact: ["", Validators.required],
      Remark: ["", Validators.required],
      ConsultantApproval: [1, Validators.required]
    });

  }

  advancePaidStatus1: boolean = false;
  advancePaidStatus2: boolean = false;
  advancePaidStatus4: boolean = false;
  advancePaidStatus7: boolean = false;
  advancePaidStatus9: boolean = false;
  advancePaidStatus10: boolean = false;
  advancePaidStatus11: boolean = false;
  advancePaidStatus12: boolean = false;
  advancePaidStatus13: boolean = false;

  dropdownSetting: any = {};
  dropdownSetting0: any = {};
  dropdownSetting1: any = {};
  dropdownSetting2: any = {};
  dropdownSetting3: any = {};
  dropdownSetting4: any = {};
  dropdownSetting5: any = {};
  dropdownSetting6: any = {};
  dropdownSetting7: any = {};
  dropdownSo: any = {};
  dropdownAc: any = {};
  dropdownAc1: any = {};
  dropdownInquiry: any = {};
  dropdownCl: any = {};
  dropdownProjectEx: any = {};
  dropdownMode: any = {};
  dropdownAdvance: any = {};
  dropdownCredit: any = {};
  submitted: boolean = false;
  multiClick: boolean = false;
  createTicket(): FormGroup {
    return this.formBuilder.group({
      Supplier: ["", Validators.required],
      ExpectedPOAGRReleaseDate: [""],
      PORemark: [""],
    });
  }
  createContract(): FormGroup {
    return this.formBuilder.group({
      Supplier: ["", Validators.required],
      ExpectedPOAGRReleaseDate: [""],
      PORemark: [""],
    });
  }

  ngOnInit(): void {
    localStorage.setItem("active_id", "tab-selectbyid1");
    let UserId = localStorage.getItem("userId");
    this.userId = this.UserService.decryptData(UserId);
    let permi = JSON.parse(localStorage.getItem("Permission"));
    this.permission = this.UserService.decryptData(permi);
    let userrId = localStorage.getItem("roleId");
    this.userRId = this.UserService.decryptData(userrId);
    let modulePermi = JSON.parse(localStorage.getItem("ModulePermission"));
    this.Modulepermi = this.UserService.decryptData(modulePermi);
    if (this.permission.OrderReview_Add != 1 && this.userRId != 1) {
      if (this.Modulepermi.OrderReview == 1) {
        this.toastrService.error("You do not have permission");
        this.router.navigate(["/orderReview/orderreview"]);
      } else {
        this.toastrService.error("You do not have permission");
        this.router.navigate(["/profile"]);
      }
      return;
    }

    this.dropdownSetting0 = {
      singleSelection: true,
      text: "Quotation Engineer",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting = {
      singleSelection: true,
      text: "Sales Engineer",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting2 = {
      singleSelection: true,
      text: "Commercial Executive",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting3 = {
      singleSelection: true,
      text: "Sales Manager",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting4 = {
      singleSelection: true,
      text: "Finance Manager",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting5 = {
      singleSelection: true,
      text: "General Manager",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting1 = {
      singleSelection: true,
      text: "Project Name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting6 = {
      singleSelection: false,
      text: "Contacts Name",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownSetting7 = {
      singleSelection: true,
      text: "Inco Terms",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: 1,
    };
    this.dropdownInquiry = {
      singleSelection: true,
      text: "Inquiry ",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownSo = {
      singleSelection: true,
      text: "So Options",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };

    this.dropdownAc = {
      singleSelection: true,
      text: "So Acknowledge",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      disabled: true,
    };

    this.dropdownAc1 = {
      singleSelection: true,
      text: "So Acknowledge",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
      disabled: false,
    };

    this.dropdownCl = {
      singleSelection: true,
      text: "Client Registration",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownProjectEx = {
      singleSelection: true,
      text: "Project Execution",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownMode = {
      singleSelection: true,
      text: "Mode of Shipment",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownAdvance = {
      singleSelection: true,
      text: "Select",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };
    this.dropdownCredit = {
      singleSelection: true,
      text: "Credit Person",
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      classes: "custom-class",
    };

    this.getproject();
    this.toValue();
    this.ddValues();
    this.getname();

    this.registerForm.get("clientSoReceive").valueChanges.subscribe((value) => {
      if (value == "Yes") {
        const validators = [Validators.required];
        this.registerForm.addControl(
          "clientSoNumber",
          this.formBuilder.control("", Validators.required)
        );
        this.registerForm.addControl(
          "clientSoDate",
          this.formBuilder.control("", Validators.required)
        );
        this.registerForm.addControl(
          "soReceiveDate",
          this.formBuilder.control("", Validators.required)
        );
        this.registerForm.removeControl("clientExDate");
      } else if (value == "No") {
        this.registerForm.addControl(
          "clientExDate",
          this.formBuilder.control("", Validators.required)
        );
        this.registerForm.removeControl("clientSoNumber");
        this.registerForm.removeControl("clientSoDate");
        this.registerForm.removeControl("soReceiveDate");
      } else if (value == "Not Applicable") {
        this.registerForm.removeControl("clientSoNumber");
        this.registerForm.removeControl("clientSoDate");
        this.registerForm.removeControl("soReceiveDate");
        this.registerForm.removeControl("clientExDate");
      }
      this.registerForm.updateValueAndValidity();
    });

    this.registerForm.get("ConsultantApproval").valueChanges.subscribe((value) => {
      if (value == 0) {
        this.registerForm.addControl(
          "ConsultantApprovalRemark",
          this.formBuilder.control("", Validators.required)
        );
      } else {
        this.registerForm.removeControl("ConsultantApprovalRemark");
      }
      this.registerForm.updateValueAndValidity();
    });

  }

  get f() {
    return this.registerForm.controls;
  }
  get c() {
    return this.commercialForm.controls;
  }

  get ObjOrderSupplier1(): any {
    let cntrl = <FormArray>this.PaymentTermInfo.get("ObjOrderSupplier");
    return cntrl.controls;
  }

  get ObjOrderSubContractor1(): any {
    let contract = <FormArray>this.PaymentTermInfo.get("ObjOrderSubContractor");
    return contract.controls;
  }

  NameSpaceNotAllowed(event: any) {
    let RegEx = /^([a-zA-Z\d!@#$&().,%*=|~[\]{}<>?'";:-])*$/g;
    let str = event.target.value;
    if (RegEx.test(str)) {
      return event.target.value;
    } else {
      let nameString = str.replace(/\s+/g, " ");
      nameString = nameString.replace(
        /[^a-zA-Z\d!@#$&()\-`.+,%*-=|~[\]{}/<>'";:]+/g,
        " "
      );
      event.target.value = nameString.replace(/^\s+/g, "");
    }
  }

  addTicket() {
    let add = <FormArray>this.PaymentTermInfo.get("ObjOrderSupplier");
    this.tvalue[add.length] = 1;
    if (add.length <= 2) {
      add.push(this.createTicket());
    } else {
      this.toastrService.error("Maximum 3 rows are allowed at once");
    }
  }

  addContract() {
    let add1 = <FormArray>this.PaymentTermInfo.get("ObjOrderSubContractor");
    this.tvalue[add1.length] = 1;
    if (add1.length <= 2) {
      add1.push(this.createContract());
    } else {
      this.toastrService.error("Maximum 3 rows are allowed at once");
    }
  }

  advancePaid1(status) {
    this.advancePaidStatus1 = status;
  }
  advancePaid2(status) {
    this.advancePaidStatus2 = status;
  }
  advancePaid4(status) {
    this.advancePaidStatus4 = status;
  }
  advancePaid7(status) {
    this.advancePaidStatus7 = status;
  }
  advancePaid9(status) {
    this.advancePaidStatus9 = status;
  }
  advancePaid10(status) {
    this.advancePaidStatus10 = status;
  }
  advancePaid11(status) {
    this.advancePaidStatus11 = status;
  }
  advancePaid12(status) {
    this.advancePaidStatus12 = status;
  }
  advancePaid13(status) {
    this.advancePaidStatus13 = status;
  }
  modo1(value: string) {
    switch (value) {
      case "true":
        this.advancePaidStatus1 = true;
        break;
      case "false":
        this.advancePaidStatus1 = false;
        break;
    }
  }
  modo2(value: string) {
    switch (value) {
      case "true":
        this.advancePaidStatus2 = true;
        break;
      case "fasle":
        this.advancePaidStatus2 = false;
        break;
    }
  }
  modo4(value: string) {
    switch (value) {
      case "true":
        this.advancePaidStatus4 = true;
        break;
      case "false":
        this.advancePaidStatus4 = false;
        break;
    }
  }

  modo7(value: string) {
    switch (value) {
      case "true":
        this.advancePaidStatus7 = true;
        break;
      case "false":
        this.advancePaidStatus7 = false;
        break;
    }
  }

  modo9(value: string) {
    switch (value) {
      case "true":
        this.advancePaidStatus9 = true;
        break;
      case "false":
        this.advancePaidStatus9 = false;
        break;
    }
  }

  modo10(value: string) {
    switch (value) {
      case "true":
        this.advancePaidStatus10 = true;
        break;
      case "false":
        this.advancePaidStatus10 = false;
        break;
    }
  }
  modo11(value: string) {
    switch (value) {
      case "true":
        this.advancePaidStatus11 = true;
        break;
      case "false":
        this.advancePaidStatus11 = false;
        break;
    }
  }
  modo12(value: string) {
    switch (value) {
      case "true":
        this.advancePaidStatus12 = true;
        break;
      case "false":
        this.advancePaidStatus12 = false;
        break;
    }
  }
  modo13(value: string) {
    switch (value) {
      case "true":
        this.advancePaidStatus13 = true;
        break;
      case "false":
        this.advancePaidStatus13 = false;
        break;
    }
  }
  LCtype: any;
  LCdiv(value) {
    if (value == "") {
      this.LCtype = "";
    }
    switch (value) {
      case "true":
        this.LCtype = "true";
        break;
      case "false":
        this.LCtype = "false";
        break;
      case "LC-3":
        this.LCtype = "LC-3";
        break;
      case "LC-4":
        this.LCtype = "LC-4";
        break;
      case "LC-5":
        this.LCtype = "LC-5";
        break;
      case "LC-6":
        this.LCtype = "LC-6";
        break;
    }
  }
  LCatype: any;
  LCadiv() {
    switch (this.selectedAdvanceId) {
      case "15":
        this.LCatype = "1";
        break;
      case "16":
        this.LCatype = "2";
        break;
      case "17":
        this.LCatype = "3";
        break;
    }
  }
  LCbtype: any;
  LCbdiv(value) {
    if (value == "") {
      this.LCbtype = "";
    }
    switch (value) {
      case "true":
        this.LCbtype = "true";
        break;
      case "false":
        this.LCbtype = "false";
        break;
      case "LCb-3":
        this.LCbtype = "LCb-3";
        break;
    }
  }
  LCctype: any;
  LCcdiv(value) {
    if (value == "") {
      this.LCctype = "";
    }
    switch (value) {
      case "LCc-1":
        this.LCctype = "LCc-1";
        break;
      case "LCc-2":
        this.LCctype = "LCc-2";
        break;
      case "LCc-3":
        this.LCctype = "LCc-3";
        break;
    }
  }
  LCdtype: any;
  LCddiv(value) {
    if (value == "") {
      this.LCdtype = "";
    }
    switch (value) {
      case "LCd-1":
        this.LCdtype = "LCd-1";
        break;
      case "LCd-2":
        this.LCdtype = "LCd-2";
        break;
      case "LCd-3":
        this.LCdtype = "LCd-3";
        break;
    }
  }
  CRtype: any;
  CRdiv() {
    switch (this.selectedClientId) {
      case "24":
        this.CRtype = "24";
        break;
      case "25":
        this.CRtype = "25";
        break;
      case "26":
        this.CRtype = "26";
        break;
    }
  }

  onDeleteRow(rowIndex) {
    let ObjOrderSupplier = this.PaymentTermInfo.get(
      "ObjOrderSupplier"
    ) as FormArray;
    if (ObjOrderSupplier.length > 1) {
      ObjOrderSupplier.removeAt(rowIndex);
    }
  }

  onDeleteRow1(rowIndex) {
    let ObjOrderSubContractor = this.PaymentTermInfo.get(
      "ObjOrderSubContractor"
    ) as FormArray;
    if (ObjOrderSubContractor.length > 1) {
      ObjOrderSubContractor.removeAt(rowIndex);
    }
  }

  newFunc(event: any) {
    this.maxStartDate = new Date(
      moment(event, "DD-MM-YYYY").format("MM-DD-YYYY")
    );
  }
  newFunc1(event: any) {
    this.maxProjDate = new Date(
      moment(event, "DD-MM-YYYY").format("MM-DD-YYYY")
    );
  }
  newFunc2(event: any) {
    this.maxClientSoDate = new Date(
      moment(event, "DD-MM-YYYY").format("MM-DD-YYYY")
    );
  }
  newFunc3(event: any) {
    this.maxEqDeliverDate = new Date(
      moment(event, "DD-MM-YYYY").format("MM-DD-YYYY")
    );
  }
  newFunc4(event: any) {
    this.maxClientExDate = new Date(
      moment(event, "DD-MM-YYYY").format("MM-DD-YYYY")
    );
  }

  vatP(event) {
    if (event.target.value > 100) {
      this.toastrService.error("Value can not be greater than 100");
    }
  }

  parseNUmber(event) {
    if (event.target.value > 999999.99) {
      this.toastrService.error("Value can not be greater than 999999.99");
    }
  }

  keyPressNumeric1(event, i) {
    const pattern = /[^0-9]/g;
    if (!pattern.test(event.target.value)) {
      event.preventDefault();
      return false;
    } else {
      event.target.value = event.target.value.replace(/[^0-9]/g, "");
      event.preventDefault();
      return false;
    }
  }

  pasteNumbrother(event, i) {
    event.target.value = "paste";
    let clipboardData = event.clipboardData || (<any>window).clipboardData;
    let pastedText = clipboardData.getData("text");
    let newText = pastedText.replace(/[^0-9]/g, "");
    this.registerForm.patchValue({ UnitRate: newText });
  }

  showProject: any = [];
  getproject() {
    let data = {};
    this.UserService.GetAllProject(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showProjectArray = res;
        this.showProject = [];
        for (const project of this.showProjectArray["Data"]) {
          {
            this.showProject.push({
              id: project["ProjectId"],
              itemName: `${project["ProjectName"]} (${project["ProjectNumber"]})`,
            });
          }
        }
      } else {
        this.showProjectArray = [];
      }
    });
  }
  selectedProject: any = [];
  selectedProjectName: any = "";
  selectedProjectId: any = "";
  onProjectSelect(item: any) {
    this.selectedProjectName = "";
    this.selectedProjectId = "";
    this.selectedProjectId = item.id;
    this.InquiryList = [];
    this.selectedInquiry = [];
    this.getinquirybyproject(this.selectedProjectId);
  }

  InquiryArray: any = [];
  InquiryList: any = [];
  getinquirybyproject(id) {
    let data = {
      ProjectId: id,
      Stage: "10",
    };
    this.UserService.GetInqueryListByProjectId(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.InquiryArray = res;
        this.InquiryList = [];
        for (const inquiryData of this.InquiryArray["Data"]) {
          this.InquiryList.push({
            id: inquiryData["InquiryId"],
            itemName: `${inquiryData["InquiryName"]} (${inquiryData["InquiryNumber"]})`,
          });
        }
      } else {
        this.InquiryList = [];
      }
    });
  }
  selectedInquiryName: any = "";
  selectedInquiryId: number = 0;
  onInquirySelect(item: any) {
    this.selectedInquiryName = "";
    this.selectedInquiryId = 0;
    this.selectedInquiry.forEach((element) => {
      this.selectedInquiryName = element["itemName"];
      this.selectedInquiryId = element["id"];
    });
    this.getContact(this.selectedInquiryId);
    this.getClient(this.selectedInquiryId);
  }

  getClient(id) {
    let data = {
      InquiryId: id,
    };
    this.UserService.GetInquiryOrderInfoById(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showClient = res["Data"];
        this.client = res["Data"]["ClientName"];
        this.clientId = res["Data"]["ClientId"];
        this.verticalName = res["Data"]["BusinessVerticalName"];
        this.categoryName = res["Data"]["BusinessCategory"];
        this.InquiryReceivedDate = new Date(
          moment(res["Data"]["InquiryReceivedDate"], "YYYY-MM-DD").format(
            "MM-DD-YYYY"
          )
        );
      } else {
        this.showClient = [];
      }
    });
  }
  selectedClient: any = [];
  selectedClientName: any;
  selectedClinetId: any;
  onClientSelect(item: any) {
    this.selectedClientName = "";
    this.selectedClinetId = "";
    this.selectedClient.forEach((element) => {
      this.selectedClientName += element["itemName"];
      this.selectedClinetId += element["id"];
    });
  }

  showname: any = [];
  showncontrat: any = [];
  getname() {
    let data = {};
    this.UserService.GetAllCompanyName(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.shownameArray = res;
        this.showname = [];
        if (this.shownameArray["Data"]) {
          for (const data of this.shownameArray["Data"]) {
            this.showname.push({
              id: data["CompanyId"],
              itemName: data["CompanyName"],
            });
          }
        }

        this.showContractArray = res;
        this.showncontrat = [];
        for (const data of this.showContractArray["Data"]) {
          this.showncontrat.push({
            id: data["CompanyId"],
            itemName: data["CompanyName"],
          });
        }
      } else {
        this.shownameArray = [];
        this.showContractArray = [];
      }
    });
  }
  
  selectedname: any = [[]]; // initialize as a 2D array with one row
  selectedName: any;
  selectedNameId: any;
  onSupplierSelect(item: any, rowIndex: number) {
    this.selectedName = "";
    this.selectedNameId = "";
    this.selectedname[rowIndex] = []; // clear the selected values for this row
    this.selectedname.forEach((element) => {
      this.selectedName += element["itemName"];
      this.selectedNameId += element["id"];
    });
  }

  selectedcontrat: any = [[]];
  selectedContractName: any;
  selectedContractId: any;
  onContractSelect(item: any, rowIndex: number) {
    this.selectedContractName = "";
    this.selectedContractId = "";
    this.selectedcontrat[rowIndex] = [];
    this.selectedcontrat.forEach((element) => {
      this.selectedContractName += element["itemName"];
      this.selectedContractId += element["id"];
    });
  }

  toValue() {
    let data = {};
    this.UserService.GetOrderReviewTOValues(data).subscribe((res) => {
      if (res["result"] == "Success") {
      } else {
      }
    });
  }

  SoOption: any = [];
  AcKnowledge: any = [];
  Client: any = [];
  ProjectEx: any = [];
  Mode: any = [];
  Advance: any = [];
  guarntee: any = [];
  modePay: any = [];
  guarnteTyp: any = [];
  ddValues() {
    let data = {};
    this.UserService.GetOrderReviewDDValues(data).subscribe((res) => {
      if (res["result"] == "Success") {
        this.showDdValuesArray = res;
        this.SoOption = [];
        for (const option of this.showDdValuesArray["SOOption"]) {
          this.SoOption.push({
            id: option["Id"],
            itemName: option["Name"],
          });
        }

        this.AcknowledgeArray = res;
        this.AcKnowledge = [];
        for (const acknowledgment of this.AcknowledgeArray[
          "SOAcknowledgement"
        ]) {
          this.AcKnowledge.push({
            id: acknowledgment["Id"],
            itemName: acknowledgment["Name"],
          });
        }

        this.ClientArray = res;
        this.Client = [];
        for (const clientOption of this.ClientArray["ReceiveOption"]) {
          this.Client.push({
            id: clientOption["Id"],
            itemName: clientOption["Name"],
          });
        }

        this.ProjectExArray = res;
        this.ProjectEx = [];
        for (const projectExecution of this.ProjectExArray[
          "ProjectExecution"
        ]) {
          this.ProjectEx.push({
            id: projectExecution["Id"],
            itemName: projectExecution["Name"],
          });
        }

        this.ModeArray = res;
        this.Mode = [];
        for (const modeOfShipment of this.ModeArray["ModeOfShipment"]) {
          this.Mode.push({
            id: modeOfShipment["Id"],
            itemName: modeOfShipment["Name"],
          });
        }

        this.modePay = res["ModeOfPayment"];
        this.AdvanceArray = res;
        this.Advance = [];
        for (const advanceAndLC of this.AdvanceArray["AdvanceAndLC"]) {
          this.Advance.push({
            id: advanceAndLC["Id"],
            itemName: advanceAndLC["Name"],
          });
        }

        this.guarnteTyp = res["GaurantyType"];
      } else {
        this.showDdValuesArray = [];
        this.AcknowledgeArray = [];
        this.ClientArray = [];
        this.ProjectExArray = [];
        this.ModeArray = [];
        this.AdvanceArray = [];
      }
    });
  }

  selectedSo: any = [];
  selectedSoName: any;
  selectedSoId: any;
  onSoSelect(item: any) {
    this.selectedSoName = "";
    this.selectedSoId = "";
    this.selectedSo.forEach((element) => {
      if (element["id"] === 1) {
        this.selectedSoName = element["itemName"];
        this.selectedSoId = element["id"];
      }

      if (element["id"] === 2) {
        this.selectedSoName = element["itemName"];
        this.selectedSoId = element["id"];
      }

      if (element["id"] === 3) {
        this.selectedSoName = element["itemName"];
        this.selectedSoId = element["id"];
      }
    });

    if (this.selectedSoId === 1) {
      this.registerForm.get("clientSoReceive").setValue("Not Applicable");
    }

    if (this.selectedSoId == 1) {
      this.selectedAc = [{ id: 6, itemName: "Not Applicable" }];
      this.selectedAcName = "Not Applicable";
      this.selectedAcId = 6;
    }

    if (this.selectedSoId == 1) {
      this.selectedProjectEx = [{ id: 7, itemName: "Self" }];
      this.selectedProjectExName = "Self";
      this.selectedProjectExId = 7;
    }

    if (this.selectedSoId === 2) {
      this.registerForm.get("clientSoReceive").setValue("Yes");
    }

    if (this.selectedSoId === 3) {
      this.registerForm.get("clientSoReceive").setValue("No");
    }
  }

  selectedAc: any = [];
  selectedAcName: any;
  selectedAcId: any;
  onAcknowledgeSelect(item: any) {
    this.registerForm.removeControl("Date");
    this.registerForm.updateValueAndValidity();
    this.selectedAcName = "";
    this.selectedAcId = "";
    this.selectedAc.forEach((element) => {
      this.selectedAcName = element["itemName"];
      this.selectedAcId = element["id"];
    });
    if (this.selectedAcId == 4 || this.selectedAcId == 5) {
      const validators = [Validators.required];
      this.registerForm.addControl(
        "Date",
        this.formBuilder.control("", Validators.required)
      );
    } else {
      this.registerForm.removeControl("Date");
    }
    this.registerForm.updateValueAndValidity();

    let currentDate = new Date();
    let currentDate2 = new Date();
    if (this.selectedAcId == 4) {
      this.minSoAckDate = new Date(
        moment(this.registerForm.value.clientSoDate, "DD-MM-YYYY").format(
          "MM-DD-YYYY"
        )
      );
      this.maxSoAckDate = currentDate;
    } else if (this.selectedAcId == 5) {
      this.minSoAckDate = currentDate;
      this.maxSoAckDate = new Date(
        currentDate2.setMonth(currentDate2.getMonth() + 1)
      );
    }
  }

  selectedClientRc: any = [];
  selectedClientRcName: any;
  selectedClientId: any;
  onClientRcSelect(item: any) {
    this.selectedClientRcName = "";
    this.selectedClientId = "";
    this.selectedClientRc.forEach((element) => {
      this.selectedClientRcName += element["itemName"];
      this.selectedClientId += element["id"];
    });
  }
  selectedProjectEx: any = [];
  selectedProjectExName: any;
  selectedProjectExId: any;
  onProjectExSelect(item: any) {
    this.selectedProjectExName = "";
    this.selectedProjectExId = "";
    this.selectedProjectEx.forEach((element) => {
      this.selectedProjectExName += element["itemName"];
      this.selectedProjectExId += element["id"];
    });
  }
  selectedAdvance: any = [];
  selectedAdvanceName: any;
  selectedAdvanceId: any;
  onAdvanceSelect(item: any) {
    this.selectedAdvanceName = "";
    this.selectedAdvanceId = "";
    this.selectedAdvance.forEach((element) => {
      this.selectedAdvanceName += element["itemName"];
      this.selectedAdvanceId += element["id"];
    });
  }
  selectedguarntee: any = [];
  selectedguarnteeName: any;
  selectedguarnteeId: any;
  onguarnteeSelect(item: any) {
    this.selectedguarnteeName = "";
    this.selectedguarnteeId = "";
    this.selectedguarntee.forEach((element) => {
      this.selectedguarnteeName += element["itemName"];
      this.selectedguarnteeId += element["id"];
    });
  }
  selectedguarntee1: any = [];
  selectedguarnteeName1: any;
  selectedguarnteeId1: any;
  onguarnteeSelect1(item: any) {
    this.selectedguarnteeName1 = "";
    this.selectedguarnteeId1 = "";
    this.selectedguarntee1.forEach((element) => {
      this.selectedguarnteeName1 += element["itemName"];
      this.selectedguarnteeId1 += element["id"];
    });
  }
  selectedguarntee2: any = [];
  selectedguarnteeName2: any;
  selectedguarnteeId2: any;
  onguarnteeSelect2(item: any) {
    this.selectedguarnteeName2 = "";
    this.selectedguarnteeId2 = "";
    this.selectedguarntee2.forEach((element) => {
      this.selectedguarnteeName2 += element["itemName"];
      this.selectedguarnteeId2 += element["id"];
    });
  }
  selectedguarntee3: any = [];
  selectedguarnteeName3: any;
  selectedguarnteeId3: any;
  onguarnteeSelect3(item: any) {
    this.selectedguarnteeName3 = "";
    this.selectedguarnteeId3 = "";
    this.selectedguarntee3.forEach((element) => {
      this.selectedguarnteeName3 += element["itemName"];
      this.selectedguarnteeId3 += element["id"];
    });
  }
  selectedguarntee4: any = [];
  selectedguarnteeName4: any;
  selectedguarnteeId4: any;
  onguarnteeSelect4(item: any) {
    this.selectedguarnteeName4 = "";
    this.selectedguarnteeId4 = "";
    this.selectedguarntee4.forEach((element) => {
      this.selectedguarnteeName4 += element["itemName"];
      this.selectedguarnteeId4 += element["id"];
    });
  }
  selectedMode: any = [];
  selectedModeName: any;
  selectedModeId: any;
  onModeSelect(item: any) {
    this.selectedModeName = "";
    this.selectedModeId = "";
    this.selectedMode.forEach((element) => {
      this.selectedModeName += element["itemName"];
      this.selectedModeId += element["id"];
    });
  }
  selectedPayment: any = [];
  selectedPaymentName: any;
  onPaymentSelect(item: any) {
    this.selectedPaymentName = "";
    this.selectedPaymentId = "";
    this.selectedPayment.forEach((element) => {
      this.selectedPaymentName += element["itemName"];
      this.selectedPaymentId += element["id"];
    });
  }
  selectedPayment1: any = [];
  selectedPaymentName1: any = "";
  selectedPaymentId1: any = "";
  onPayment1Select(item: any) {
    this.selectedPaymentName1 = "";
    this.selectedPaymentId1 = "";
    this.selectedPayment1.forEach((element) => {
      this.selectedPaymentName1 += element["itemName"];
      this.selectedPaymentId1 += element["id"];
    });
  }
  selectedPayment2: any = [];
  selectedPaymentName2: any;
  selectedPaymentId2: any;
  onPayment2Select(item: any) {
    this.selectedPaymentName2 = "";
    this.selectedPaymentId2 = "";
    this.selectedPayment1.forEach((element) => {
      this.selectedPaymentName2 += element["itemName"];
      this.selectedPaymentId2 += element["id"];
    });
  }
  selectedPayment3: any = [];
  selectedPaymentName3: any;
  selectedPaymentId3: any;
  onPayment3Select(item: any) {
    this.selectedPaymentName3 = "";
    this.selectedPaymentId3 = "";
    this.selectedPayment3.forEach((element) => {
      this.selectedPaymentName3 += element["itemName"];
      this.selectedPaymentId3 += element["id"];
    });
  }
  selectedPayment4: any = [];
  selectedPaymentName4: any;
  selectedPaymentId4: any;
  onPayment4Select(item: any) {
    this.selectedPaymentName4 = "";
    this.selectedPaymentId4 = "";
    this.selectedPayment4.forEach((element) => {
      this.selectedPaymentName4 += element["itemName"];
      this.selectedPaymentId4 += element["id"];
    });
  }
  selectedPayment5: any = [];
  selectedPaymentName5: any;
  selectedPaymentId5: any;
  onPayment5Select(item: any) {
    this.selectedPaymentName5 = "";
    this.selectedPaymentId5 = "";
    this.selectedPayment1.forEach((element) => {
      this.selectedPaymentName5 += element["itemName"];
      this.selectedPaymentId5 += element["id"];
    });
  }
  selectedPayment6: any = [];
  selectedPaymentName6: any;
  selectedPaymentId6: any;
  onPayment6Select(item: any) {
    this.selectedPaymentName6 = "";
    this.selectedPaymentId6 = "";
    this.selectedPayment6.forEach((element) => {
      this.selectedPaymentName6 += element["itemName"];
      this.selectedPaymentId6 += element["id"];
    });
  }
  selectedPayment7: any = [];
  selectedPaymentName7: any;
  selectedPaymentId7: any;
  onPayment7Select(item: any) {
    this.selectedPaymentName7 = "";
    this.selectedPaymentId7 = "";
    this.selectedPayment7.forEach((element) => {
      this.selectedPaymentName7 += element["itemName"];
      this.selectedPaymentId7 += element["id"];
    });
  }
  selectedPayment8: any = [];
  selectedPaymentName8: any;
  selectedPaymentId8: any;
  onPayment8Select(item: any) {
    this.selectedPaymentName8 = "";
    this.selectedPaymentId8 = "";
    this.selectedPayment8.forEach((element) => {
      this.selectedPaymentName8 += element["itemName"];
      this.selectedPaymentId8 += element["id"];
    });
  }

  onItemSelect(item: any) {}
  OnItemDeSelect(item: any) {}

  showContact: any = [];
  getContact(id) {
    let data = {
      InquiryId: id,
    };
    this.UserService.GetClientContactByInquiryId(data).subscribe((res) => {
      if (res["result"] == "success") {
        this.showContact = [];
        this.showContactArray = res;
        for (const contactData of this.showContactArray["Data"]) {
          this.showContact.push({
            id: contactData["ContactId"],
            itemName: `${contactData["ContactName"]} (${contactData["Email"]})`,
          });
        }
      } else {
        this.showContactArray = [];
      }
    });
  }
  selectedcontact: any = [];
  selectedContact: any;
  selectedContactId: any;
  onContactSelect(item: any) {
    this.selectedContact = "";
    this.selectedContactId = "";
    this.selectedcontact.forEach((element) => {
      this.selectedContact += element["itemName"] + ", ";
      this.selectedContactId += element["id"] + ", ";
    });
  }

  onSubmit() {
    this.submitted = true;
    if (
      this.registerForm.value.clientSoDate == null ||
      this.registerForm.value.clientSoDate == ""
    ) {
      this.registerForm.value.clientSoDate = null;
    } else {
      this.registerForm.value.clientSoDate = moment(
        this.registerForm.value.clientSoDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (
      this.registerForm.value.soReceiveDate == null ||
      this.registerForm.value.soReceiveDate == ""
    ) {
      this.registerForm.value.soReceiveDate = null;
    } else {
      this.registerForm.value.soReceiveDate = moment(
        this.registerForm.value.soReceiveDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (
      this.registerForm.value.clientExDate == null ||
      this.registerForm.value.clientExDate == ""
    ) {
      this.registerForm.value.clientExDate = null;
    } else {
      this.registerForm.value.clientExDate = moment(
        this.registerForm.value.clientExDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (
      this.registerForm.value.Date == null ||
      this.registerForm.value.Date == ""
    ) {
      this.registerForm.value.Date = null;
    } else {
      this.registerForm.value.Date = moment(
        this.registerForm.value.Date,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }
    if (
      this.registerForm.value.eqDeliveryDate == null ||
      this.registerForm.value.eqDeliveryDate == ""
    ) {
      this.registerForm.value.eqDeliveryDate = null;
    } else {
      this.registerForm.value.eqDeliveryDate = moment(
        this.registerForm.value.eqDeliveryDate,
        "DD-MM-YYYY"
      ).format("YYYY-MM-DD");
    }

    let data = {
      OrderInfoId: 0,
      SOOption: this.selectedSoId,
      CriticalShipment: this.registerForm.value.criticalShipment,
      ProjectId: this.selectedProjectId,
      InquiryId: this.selectedInquiryId,
      ClientId: this.clientId,
      ClientSOAGR: this.registerForm.value.clientSoReceive,
      ClientSONumber: this.registerForm.value.clientSoNumber,
      ClientSODate: this.registerForm.value.clientSoDate,
      ClientSOExpDate: this.registerForm.value.clientExDate,
      SOReceivedDate: this.registerForm.value.soReceiveDate,
      RemarksSOReceiveDate: this.registerForm.value.remarkRcDate,
      SOAcknowledgement: this.selectedAcId,
      SOAcknowledgementdate: this.registerForm.value.Date,
      ProjectExecution: this.selectedProjectExId,
      EquipmentDeliveryDate: this.registerForm.value.eqDeliveryDate,
      EquipmentDeliveryRemark: this.registerForm.value.eqDeliveryRemark,
      ScopeOfWork: this.registerForm.value.scopeWork,
      ClientContact: this.selectedContactId,
      Remark: this.registerForm.value.Remark,
      ConsultantApproval: this.registerForm.value.ConsultantApproval,
      ConsultantApprovalRemark: this.registerForm.value.ConsultantApprovalRemark
    };
    if (this.registerForm.valid) {
      this.multiClick = true;
      this.spinner.show();
      this.UserService.AddUpdateOrderInformation(data).subscribe(
        (res) => {
          if (res["result"] == "success") {
            this.orderId = res["Data"]["OrderInfoId"];
            this.check = 1;
            this.toastrService.success(res["Msg"]);
            let encryptid = this.UserService.encryptData(this.orderId);
            encryptid = encryptid.toString().replace("=", "Ar1t").replace("/", "FGH").replace("+", "THD");
            this.router.navigate(["/orderReview/editproductreview", encryptid]);
          } else if (res["result"] == "Failed") {
            this.toastrService.error(res["Msg"]);
            this.spinner.hide();
          } else {
            this.toastrService.error(res["Message"]);
            this.spinner.hide();
          }
          this.submitted = false;
          this.multiClick = false;
        },
        (err) => {
          this.spinner.hide();
          if (err && (err.Msg || err.Message)) {
            this.toastrService.error(err.Msg || err.Message);
          }
          this.multiClick = false;
        }
      );
    } else {
      this.toastrService.error("Please Fill All Required fields");
      this.submitted = true;
      this.multiClick = false;
    }
  }
}
